<script>
    import {createEventDispatcher} from "svelte";
    import {copyObj} from "../../lib/lib.js";

    export let data;
    let checked;

    let myData = copyObj(data);

    const dispatch = createEventDispatcher();

    $: {
        dd('changed')
        dispatch('setItem', {id: data.id, checked} )
    }
</script>

<div class="flex items-center gap-sm mb-2">
    <input type="checkbox" bind:checked>
    <div class="flex-1 leading-tight" class:text-gray={!checked}>
        {myData.name}
    </div>
</div>